import { MenuButton, MenuItemWithIcon, ModalOpenButton } from "@msys/ui";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { useTranslate } from "@tolgee/react";
import { AddressInput } from "../../../clients/graphqlTypes.js";
import {
  getAddressInfoFromPlace,
  getLocationFromPlace,
  GoogleAddressSearch,
} from "../../commons/GoogleAddressSearch.js";
import { Address } from "./Address.js";
import { AddressDetails__AddressFragment } from "./Addresses.generated.js";
import { GetAddressModal } from "./GetAddressModal.js";

interface Props {
  label: string;
  address: AddressDetails__AddressFragment | null;
  handleChange: (address: AddressInput | null) => void;
  allowCustom?: boolean;
}

export const AddressComboField = ({
  label,
  address,
  handleChange,
  allowCustom = false,
}: Props) => {
  const { t } = useTranslate("Address");

  if (!address) {
    return (
      <GoogleAddressSearch<never, never>
        label={label}
        onChange={value => {
          if (!value) {
            handleChange(null);
          } else {
            const address = getAddressInfoFromPlace(value.place);
            const location = getLocationFromPlace(value.place);
            handleChange({
              streetLines1: address.streetLines1,
              postalCode: address.postalCode ?? "",
              city: address.city ?? "",
              countryCode: address.countryCode ?? "",
              location,
            });
          }
        }}
      />
    );
  }

  return (
    <Address
      label={label}
      address={address}
      actionButtons={
        <MenuButton>
          <ModalOpenButton
            Modal={GetAddressModal}
            modalProps={{
              inputLabel: label,
              value: address,
              handleComplete: async (address, handleClose) => {
                handleChange(address);
                handleClose();
              },
              allowCustom,
            }}
          >
            <MenuItemWithIcon icon={<EditIcon />}>
              {t("Edit address")}
            </MenuItemWithIcon>
          </ModalOpenButton>
          <MenuItemWithIcon
            icon={<DeleteIcon />}
            onClick={() => {
              handleChange(null);
            }}
          >
            {t("Delete address")}
          </MenuItemWithIcon>
        </MenuButton>
      }
    />
  );
};
